import { type ISbStoryData } from '@storyblok/react/rsc'

import { cmsGetStoryblokLinkHref } from '../../cmsStoryblokLinkProps'
import { cmsStoryblokSlugToPublicUrl } from '../../cmsStoryblokSlugToPublicUrl'
import { type ContentType } from '../../storyblok'

/**
 * returns seoCanonical:
 * - if linked story -> absolute path with domain/host
 * - if string -> return as is
 * - if empty -> return full absolute URL for story
 */
export const storyAccessorGetCanonicalUrl = (
  story: ISbStoryData<ContentType>,
): string => {
  if (story.content.seoCanonical) {
    const seoCanonical = cmsGetStoryblokLinkHref(story.content.seoCanonical)

    if (seoCanonical) {
      return seoCanonical
    }
  }

  return cmsStoryblokSlugToPublicUrl(story.full_slug, {
    addTenantHostFromPathPrefix: true,
  })
}
